import selectColor from "@/components/common/selectColorTypeVideo";
import { SITE_DOMAIN } from "@/constant";
export const VideoInitialData = {
  payload: {
    name: "",
    sharing: "1",
    showButton: false,
    design_colors_primary: selectColor[0].color,
    design_colors_button: selectColor[0].buttonColor,
    headline: "",
    company: "",
    description: "",
    welcome_screen: "",
    welcome_path: "",
    videos: [
      {
        image: "https://i.ytimg.com/vi/pmTo3fHK9uE/sddefault.jpg",
        name: "Your video headline",
        url: "https://www.youtube.com/watch?v=pmTo3fHK9uE&t=213s&ab_channel=BakeWithAngus",
      },
    ],
    button: "",
    button_url: "",
    highlight_the_first_video: "0",
    socialItems: [
      {
        id: 0,
        icon: "/social-items/website.svg",
        url: "",
        type: "website",
      },
      {
        id: 1,
        icon:"/social-items/youtube.svg",
        url: "",
        type: "youtube",
      },
      {
        id: 2,
        icon: "/social-items/instagram.svg",
        url: "",
        type: "instagram",
      },
    ],
  },
};

export const AddButtonVideoInitialData = [
  {
    value: "Shop online",
    icon: "",
  },
  {
    value: "Learn more",
    icon: "",
  },
  {
    value: "Apply now",
    icon: "",
  },
  {
    value: "Custom",
    icon: "/common/edit-icon.svg",
  },
];
